module.exports = __webpack_public_path__ + "img/DK27648029.fc27a6d1.png";